module.exports = __webpack_public_path__ + "assets/img/ic-make.6a9fe140.svg";